package diana.soleil.design.iraniancanadienbazzar.feature.chat

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppConfirmDialog
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ChatBubble
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ChatInputBar
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ErrorState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportReason
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportStatus
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.appContentWidth
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_block_cancel
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_block_confirm
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_block_message
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_block_title
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_block_title_generic
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_block_user_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_quick_available
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_quick_meet
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_quick_price
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_report_done
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_report_failed
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_report_reason_harassment
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_report_reason_offensive
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_report_reason_scam
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_report_reason_spam
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_report_submit
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_report_user_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_report_user_sent
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_report_user_title
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_safety_note
import diana.soleil.design.iraniancanadienbazzar.core.model.Language
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_send_failed
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_time_am
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_time_pm
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime
import kotlin.time.Instant
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.chat_unnamed_member
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.convo_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.convo_empty_desc
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.convo_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.convo_error
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.convo_input_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.convo_request_accept
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.convo_request_decline
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.convo_request_note
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.convo_group_request_note
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.convo_leave_group
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.convo_retry
import diana.soleil.design.iraniancanadienbazzar.feature.chat.resources.convo_send_a11y
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf

/**
 * Stateful conversation entry. Reached with a [conversationId] (from the inbox) or a [businessId]
 * (business detail's Chat button — the thread is created on first contact). Guests are bounced to
 * sign-in.
 */
@Composable
fun ConversationRoute(
    conversationId: String?,
    businessId: String?,
    onBack: () -> Unit,
    onRequireSignIn: () -> Unit,
    modifier: Modifier = Modifier,
    viewModel: ConversationViewModel = koinViewModel(parameters = { parametersOf(conversationId, businessId) }),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    var showReportSheet by remember { mutableStateOf(false) }
    var showBlockDialog by remember { mutableStateOf(false) }
    LaunchedEffect(state.signInRequired) {
        if (state.signInRequired) onRequireSignIn()
    }
    // Guests can open the report sheet but the submission is gated server-side — bounce to sign-in.
    LaunchedEffect(state.reportStatus) {
        if (state.reportStatus == ChatReportStatus.SignInRequired) {
            showReportSheet = false
            viewModel.resetReport()
            onRequireSignIn()
        }
    }
    // A successful block hides this thread from the inbox — back out of the now-invisible thread.
    LaunchedEffect(state.blockCompleted) {
        if (state.blockCompleted) onBack()
    }
    // Declining a request deletes the thread — back out of the now-gone thread.
    LaunchedEffect(state.requestDeclined) {
        if (state.requestDeclined) onBack()
    }
    ConversationScreen(
        state = state,
        onBack = onBack,
        onSend = viewModel::send,
        onClearSendError = viewModel::clearSendFailed,
        onRetry = viewModel::retry,
        onReportUser = { showReportSheet = true },
        onBlockUser = { showBlockDialog = true },
        onAcceptRequest = viewModel::acceptRequest,
        onDeclineRequest = viewModel::declineRequest,
        onLeaveGroup = viewModel::leaveGroup,
        modifier = modifier,
    )

    if (showReportSheet) {
        ReportSheet(
            title = stringResource(Res.string.chat_report_user_title),
            reasons = listOf(
                ReportReason(stringResource(Res.string.chat_report_reason_harassment), "harassment"),
                ReportReason(stringResource(Res.string.chat_report_reason_spam), "spam"),
                ReportReason(stringResource(Res.string.chat_report_reason_scam), "scam"),
                ReportReason(stringResource(Res.string.chat_report_reason_offensive), "offensive_content"),
            ),
            status = when (state.reportStatus) {
                ChatReportStatus.Sending -> ReportStatus.Sending
                ChatReportStatus.Sent -> ReportStatus.Sent
                ChatReportStatus.Failed -> ReportStatus.Failed
                ChatReportStatus.Idle, ChatReportStatus.SignInRequired -> ReportStatus.Idle
            },
            sentText = stringResource(Res.string.chat_report_user_sent),
            failedText = stringResource(Res.string.chat_report_failed),
            submitText = stringResource(Res.string.chat_report_submit),
            doneText = stringResource(Res.string.chat_report_done),
            onSubmit = viewModel::report,
            onDismiss = {
                showReportSheet = false
                viewModel.resetReport()
            },
        )
    }

    if (showBlockDialog) {
        AppConfirmDialog(
            // Item threads are titled after the listing, not a person — a name-parameterized title
            // would read "Block <item title>?", so those use the generic wording instead.
            title = if (state.isItemThread) stringResource(Res.string.chat_block_title_generic)
            else stringResource(Res.string.chat_block_title, state.businessName),
            message = stringResource(Res.string.chat_block_message),
            confirmLabel = stringResource(Res.string.chat_block_confirm),
            cancelLabel = stringResource(Res.string.chat_block_cancel),
            destructive = true,
            onConfirm = {
                state.counterpartyUid?.let(viewModel::blockUser)
                showBlockDialog = false
            },
            onDismiss = { showBlockDialog = false },
        )
    }
}

/**
 * Chat thread (Stitch `c8110400`): back + initial-avatar + business-name header, message bubbles
 * (mine end/teal, theirs start/surface), pill composer + teal send button. Deviations from Stitch
 * (deliberate): no presence line ("Online • replies in 5m" — we have no presence system), no
 * rich booking cards (later phase), no call/menu icons in the header (call lives on the business
 * detail). Tokens + string resources only.
 */
@Composable
fun ConversationScreen(
    state: ConversationUiState,
    onBack: () -> Unit,
    onSend: (String) -> Unit,
    onClearSendError: () -> Unit,
    onRetry: () -> Unit,
    onReportUser: () -> Unit,
    onBlockUser: () -> Unit,
    onAcceptRequest: () -> Unit = {},
    onDeclineRequest: () -> Unit = {},
    onLeaveGroup: () -> Unit = {},
    modifier: Modifier = Modifier,
) {
    var draft by remember { mutableStateOf("") }
    var sendInFlight by remember { mutableStateOf(false) }
    val listState = rememberLazyListState()

    // The draft is only cleared once a send completes successfully — on failure it stays in the
    // composer so the user can tap send again without retyping.
    LaunchedEffect(state.sending, state.sendFailed) {
        if (sendInFlight && !state.sending) {
            if (!state.sendFailed) draft = ""
            sendInFlight = false
        }
    }

    // Keep the newest message in view as they stream in (the item-thread safety note occupies
    // index 0, so the newest message sits one index further down).
    LaunchedEffect(state.messages.size, state.isItemThread) {
        if (state.messages.isNotEmpty()) {
            val safetyOffset = if (state.isItemThread) 1 else 0
            listState.animateScrollToItem(state.messages.size - 1 + safetyOffset)
        }
    }

    Column(modifier = modifier.background(AppTheme.colors.background).appContentWidth(AppTheme.sizes.contentMaxWidth).fillMaxHeight().navigationBarsPadding().imePadding()) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .background(AppTheme.colors.surface)
                .statusBarsPadding()
                .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            AppIconButton(
                iconName = "arrow_back",
                contentDescription = stringResource(Res.string.convo_back_a11y),
                onClick = onBack,
                tint = AppTheme.colors.onSurface,
            )
            // Same blank-name guard as the inbox: pre-2026-09-17 threads can hold an empty name.
            val headerName = state.businessName.ifBlank { stringResource(Res.string.chat_unnamed_member) }
            Box(
                modifier = Modifier
                    .size(AppTheme.sizes.avatarSm)
                    .background(AppTheme.colors.categoryChip, AppTheme.shapes.pill),
                contentAlignment = Alignment.Center,
            ) {
                Text(
                    text = headerName.take(1).uppercase(),
                    style = AppTheme.typography.labelMd,
                    color = AppTheme.colors.primary,
                )
            }
            Text(
                text = headerName,
                style = AppTheme.typography.headlineMd,
                color = AppTheme.colors.onSurface,
                modifier = Modifier.weight(1f),
            )
            if (state.isGroup && !state.isPendingRequest && !state.loading) {
                AppIconButton(
                    iconName = "logout",
                    contentDescription = stringResource(Res.string.convo_leave_group),
                    onClick = onLeaveGroup,
                    tint = AppTheme.colors.onSurfaceVariant,
                )
            }
            // Trust/safety actions appear once the thread doc resolved the counterparty.
            if (state.counterpartyUid != null && !state.isGroup) {
                AppIconButton(
                    iconName = "flag",
                    contentDescription = stringResource(Res.string.chat_report_user_a11y),
                    onClick = onReportUser,
                    tint = AppTheme.colors.onSurfaceVariant,
                )
                AppIconButton(
                    iconName = "block",
                    contentDescription = stringResource(Res.string.chat_block_user_a11y),
                    onClick = onBlockUser,
                    tint = AppTheme.colors.onSurfaceVariant,
                )
            }
        }

        when {
            state.error -> ErrorState(
                message = stringResource(Res.string.convo_error),
                onRetry = onRetry,
                retryLabel = stringResource(Res.string.convo_retry),
                modifier = Modifier.weight(1f),
            )
            state.loading -> LoadingState(modifier = Modifier.weight(1f))
            else -> LazyColumn(
                state = listState,
                modifier = Modifier.weight(1f),
                contentPadding = PaddingValues(
                    start = AppTheme.spacing.lg,
                    end = AppTheme.spacing.lg,
                    top = AppTheme.spacing.md,
                    bottom = AppTheme.spacing.md,
                ),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            ) {
                // Marketplace threads open with a one-glance meetup-safety reminder.
                if (state.isItemThread) {
                    item(key = "chat_safety_note") {
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.card)
                                .padding(AppTheme.spacing.md),
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                        ) {
                            AppIcon(
                                name = "shield",
                                size = AppTheme.sizes.iconSm,
                                tint = AppTheme.colors.onSurfaceVariant,
                            )
                            Text(
                                text = stringResource(Res.string.chat_safety_note),
                                style = AppTheme.typography.bodySm,
                                color = AppTheme.colors.onSurfaceVariant,
                                modifier = Modifier.weight(1f),
                            )
                        }
                    }
                }
                if (state.messages.isEmpty()) {
                    item {
                        EmptyState(
                            title = stringResource(Res.string.convo_empty_title),
                            description = stringResource(Res.string.convo_empty_desc),
                        )
                    }
                } else {
                    items(count = state.messages.size, key = { state.messages[it].id }) { index ->
                        val message = state.messages[index]
                        // Group threads label who wrote (snapshotted display names); every bubble
                        // shows its send time (was blank — below messaging-app baseline).
                        val sender = if (state.isGroup && !message.isMine) {
                            state.senderNames[message.senderUid]?.takeIf { it.isNotBlank() }
                        } else null
                        val time = message.createdAtMillis?.let { clockTimeLabel(it) }
                        ChatBubble(
                            text = message.text,
                            mine = message.isMine,
                            metaLabel = listOfNotNull(sender, time).joinToString(" · ").takeIf { it.isNotEmpty() },
                        )
                    }
                }
            }
        }

        if (!state.error) {
            if (state.sendFailed) {
                Text(
                    text = stringResource(Res.string.chat_send_failed),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onErrorContainer,
                    modifier = Modifier.padding(
                        horizontal = AppTheme.spacing.lg,
                        vertical = AppTheme.spacing.xs,
                    ),
                )
            }
            // Marketplace quick replies — tapping fills the composer (never auto-sends).
            if (state.isItemThread) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .horizontalScroll(rememberScrollState())
                        .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.xs),
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                ) {
                    listOf(
                        stringResource(Res.string.chat_quick_available),
                        stringResource(Res.string.chat_quick_price),
                        stringResource(Res.string.chat_quick_meet),
                    ).forEach { quickReply ->
                        AppChip(
                            label = quickReply,
                            onClick = {
                                draft = quickReply
                                if (state.sendFailed) onClearSendError()
                            },
                        )
                    }
                }
            }
            // A pending message request replaces the composer with Accept / Decline until accepted.
            if (state.isPendingRequest) {
                RequestBanner(
                    isGroup = state.isGroup,
                    onAccept = onAcceptRequest,
                    onDecline = onDeclineRequest,
                )
            } else {
                ChatInputBar(
                    value = draft,
                    onValueChange = {
                        draft = it
                        if (state.sendFailed) onClearSendError()
                    },
                    onSend = {
                        if (draft.isNotBlank() && !state.sending) {
                            sendInFlight = true
                            onSend(draft)
                        }
                    },
                    placeholder = stringResource(Res.string.convo_input_placeholder),
                    sendContentDescription = stringResource(Res.string.convo_send_a11y),
                    sending = state.sending,
                )
            }
        }
    }
}

/** Message-request footer: this person wants to message you — Accept to reply, or Decline to remove. */
@Composable
private fun RequestBanner(isGroup: Boolean, onAccept: () -> Unit, onDecline: () -> Unit) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(AppTheme.colors.surface)
            .padding(AppTheme.spacing.lg),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        Text(
            text = stringResource(
                if (isGroup) Res.string.convo_group_request_note else Res.string.convo_request_note,
            ),
            style = AppTheme.typography.bodyMd,
            color = AppTheme.colors.onSurfaceVariant,
        )
        Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
            AppButton(
                text = stringResource(Res.string.convo_request_accept),
                onClick = onAccept,
                modifier = Modifier.weight(1f),
                leadingIcon = "check",
            )
            AppButton(
                text = stringResource(Res.string.convo_request_decline),
                onClick = onDecline,
                modifier = Modifier.weight(1f),
                variant = AppButtonVariant.Secondary,
                leadingIcon = "close",
            )
        }
    }
}

/** A message's send time: 12-hour clock with AM/PM for English, 24-hour for French/Farsi. */
@OptIn(ExperimentalTime::class)
@Composable
private fun clockTimeLabel(epochMillis: Long): String {
    val dateTime = Instant.fromEpochMilliseconds(epochMillis)
        .toLocalDateTime(TimeZone.currentSystemDefault())
    val minute = dateTime.minute.toString().padStart(2, '0')
    return if (AppTheme.language == Language.EN) {
        val hour12 = (dateTime.hour % 12).let { if (it == 0) 12 else it }
        val suffix = if (dateTime.hour < 12) stringResource(Res.string.chat_time_am) else stringResource(Res.string.chat_time_pm)
        "$hour12:$minute $suffix"
    } else {
        "${dateTime.hour}:$minute"
    }
}
